exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sortable-ghost {\n  opacity: .8;\n  color: #fff !important;\n  background: #42b983 !important;\n}\n", ""]);

// exports
